import clsx from 'clsx';
import { Link } from 'react-router-dom';
import { Button } from 'src/common/Button/Button';
import { I18n } from 'src/modules/common/components/I18n/I18n';
import { MESSAGES } from 'src/modules/common/constants';
import { ArrowRightIcon } from 'src/modules/common/icons/ArrowRightIcon';
import { PATHS } from 'src/sensors/common/types/Paths';

type Props = {
    searchParams: URLSearchParams;
    isMobile: boolean;
}

export const SensorsSelectSensorButton = ({ searchParams, isMobile }: Props) => (
    <Button
        as={Link}
        className={clsx({
            'vss-sensors-select-sensor-button': true,
            'vss-sensors-select-sensor-button--mobile': isMobile,
        })}
        fullWidth={isMobile}
        to={{
            pathname: PATHS.Accessories,
            search: searchParams.toString(),
        }}
        size="md"
        icon={(
            <div className="vss-sensors-select-sensor-button__icon">
                <ArrowRightIcon/>
            </div>
        )}
    >
        <I18n messageId={MESSAGES.selectDevice}/>
    </Button>
);
